import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-docs",
  templateUrl: "./med-icon-docs.component.html",
})
export class MedIconDocsComponent extends SvgMixinLargeComponent { }
